import script from "./WeeklyComparisonChart.vue?vue&type=script&setup=true&lang=js"
export * from "./WeeklyComparisonChart.vue?vue&type=script&setup=true&lang=js"

import "./WeeklyComparisonChart.vue?vue&type=style&index=0&id=893f91ae&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-893f91ae"]])

export default __exports__